// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiPaper-root .send-message-failed {
    background-color: rgb(255, 204, 204);
}

.sending-message-in-proccess {
    opacity: .5;
}

.sending-message-resend {
    float: right;
}

.sending-message-spinner {
    float: right;
}

.sending-message-text {
    float: left;
    padding-left: 1.4rem;
    word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/MessageItem/SendingMessage/SendingMessage.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,sBAAsB;AAC1B","sourcesContent":[".MuiPaper-root .send-message-failed {\r\n    background-color: rgb(255, 204, 204);\r\n}\r\n\r\n.sending-message-in-proccess {\r\n    opacity: .5;\r\n}\r\n\r\n.sending-message-resend {\r\n    float: right;\r\n}\r\n\r\n.sending-message-spinner {\r\n    float: right;\r\n}\r\n\r\n.sending-message-text {\r\n    float: left;\r\n    padding-left: 1.4rem;\r\n    word-break: break-word;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
